import { ModalCustom } from "components/ModalCustom";
import { useCallback, useState } from "react";
import { FaCheck, FaExclamation, FaTimes } from "react-icons/fa";
import { Corpo, Icone } from "./style";

export type TipoRetorno = "sucesso" | "aviso" | "erro";

const ICONES: Record<TipoRetorno, JSX.Element> = {
  sucesso: <FaCheck />,
  aviso: <FaExclamation />,
  erro: <FaTimes />,
};

interface IRetorno {
  titulo: string;
  mensagem: string;
  tipo: TipoRetorno;
}

interface IProps extends IRetorno {
  show: boolean;
  handleClose: () => void;
}

export function ModalRetorno({
  show,
  handleClose,
  titulo,
  mensagem,
  tipo,
}: IProps) {
  return (
    <ModalCustom show={show} handleClose={handleClose} title={titulo} centered>
      <Corpo>
        <Icone $tipo={tipo}>{ICONES[tipo]}</Icone>
        {mensagem}
      </Corpo>
    </ModalCustom>
  );
}

export function useModalRetorno() {
  const [retorno, setRetorno] = useState<IRetorno>({
    titulo: "",
    mensagem: "",
    tipo: "sucesso",
  });
  const [show, setShow] = useState(false);

  const mostrarRetorno = useCallback(
    (titulo: string, mensagem: string, tipo: TipoRetorno = "sucesso") => {
      setRetorno({ titulo, mensagem, tipo });
      setShow(true);
    },
    []
  );

  return {
    mostrarRetorno,
    propsModalRetorno: { ...retorno, show, handleClose: () => setShow(false) },
  };
}
